import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

export const redirectOnNullQueryParamsGuard: CanActivateFn = (
  _activatedRouteSnapShot: ActivatedRouteSnapshot,
) => {
  const router = inject(Router);
  const editMode = _activatedRouteSnapShot.queryParamMap.get('editMode');
  if (editMode === null) {
    router.navigate(['/admin/roles']);
    return false;
  }
  return true;
};
